var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotfmanageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 109.398,
    height: 56.102,
    viewBox: "0 0 109.398 56.102",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #6283a3;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #294b6e;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #ff0;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Notification_Management",
    "data-name": "Notification Management",
    transform: "translate(-6.199 -0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2670",
    "data-name": "Path 2670",
    className: "cls-1",
    d: "M80.491,34.082a11.1,11.1,0,0,0-2.959.445A19.55,19.55,0,0,0,53.164,17.889,28.056,28.056,0,0,0,30,.578V56.523H80.491a11.22,11.22,0,1,0,0-22.44Z",
    transform: "translate(23.886 0.078)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2671",
    "data-name": "Path 2671",
    className: "cls-2",
    d: "M51.081.5A28.057,28.057,0,0,0,23.589,22.968c-.186-.006-.371-.028-.559-.028a16.83,16.83,0,1,0,0,33.661H53.886V.656C52.962.564,52.028.5,51.081.5Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_698",
    "data-name": "Group 698",
    transform: "translate(28.599 24.806)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2672",
    "data-name": "Path 2672",
    className: "cls-3",
    d: "M20.374,23.905l-.842-2.21c-.433-1.136-1.132-2.384-.982-3.625.291-2.4,2.246-4.781,4.855-4.484a5.015,5.015,0,0,1,4.133,2.757c.4.827.661,1.731.988,2.587l.437,1.15c.042.11.094.409.186.487l2.028,1.745s.709.561.006.9L20.52,27.269s-.793.106-.625-.665Z",
    transform: "translate(-16.225 -11.697)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2673",
    "data-name": "Path 2673",
    className: "cls-3",
    d: "M21.6,20.51a2.035,2.035,0,0,0,.066.214,1.756,1.756,0,0,0,3.282-1.248,1.886,1.886,0,0,0-.094-.2Z",
    transform: "translate(-13.141 -5.966)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2674",
    "data-name": "Path 2674",
    className: "cls-3",
    d: "M21.963,14.242a1.257,1.257,0,0,0-.044-.14,1.151,1.151,0,1,0-2.152.819,1.013,1.013,0,0,0,.06.134Z",
    transform: "translate(-15.059 -11.9)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_696",
    "data-name": "Group 696",
    transform: "translate(0 3.206)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2675",
    "data-name": "Path 2675",
    className: "cls-3",
    d: "M17.944,19.729a.4.4,0,0,1-.13.026.407.407,0,0,1-.425-.391,11.869,11.869,0,0,1,.876-4.891.409.409,0,0,1,.747.335,11.293,11.293,0,0,0-.805,4.522A.406.406,0,0,1,17.944,19.729Z",
    transform: "translate(-17.379 -14.231)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_697",
    "data-name": "Group 697",
    transform: "translate(9.276)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2676",
    "data-name": "Path 2676",
    className: "cls-3",
    d: "M26.321,16.38a.407.407,0,0,1-.463-.122,11.281,11.281,0,0,0-3.606-2.843.409.409,0,0,1,.335-.747,11.868,11.868,0,0,1,3.905,3.072.409.409,0,0,1-.058.577A.37.37,0,0,1,26.321,16.38Z",
    transform: "translate(-22.009 -12.631)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotfmanageIcon);
export default __webpack_public_path__ + "static/media/NotfmanageIcon.3c5b435aeda9670fe22920edd839d0dc.svg";
export { ForwardRef as ReactComponent };